import React, { useEffect } from "react";
import {
  Document,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { Colors } from "../../../assets/Colors";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../../fetchers";
import LOGO_RKS from "../../../assets/logo/LOGO_RKS.png";

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
  },
  viewHeader: {
    width: 200,

    marginLeft: 150,
  },
  title_sub: {
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "center",
  },
  header_kepada: {
    fontWeight: "bold",
    fontSize: 12,
  },
  bottom_ttd: {
    paddingTop: 50,
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "center",
    border: 1,
    width: 132,
  },
  bottom_ttdL: {
    paddingTop: 50,
    paddingLeft: 5,
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "left",
    border: 1,
    width: 132,
  },
  bottom_ttdB: {
    paddingLeft: 5,
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "left",
    border: 1,
    borderTop: 0,
    width: 132,
  },

  header_namasupp: {
    fontWeight: "bold",
    fontSize: 12,
    textTransform: "capitalize",
  },
  title_border: {
    marginBottom: 20,
    fontSize: 12,
    textAlign: "center",
  },
  Stitle_border: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 20,
    marginRight: 15,
  },

  header_section: {
    flexDirection: "row",
  },

  header_title: {
    width: 270,
    fontSize: 9,
    textAlign: "justify",
  },
  header_Right: {
    width: 70,
    marginLeft: 105,
    fontSize: 9,
    textAlign: "left",
  },
  header_Rightv: {
    width: 70,
    marginLeft: 133,
    fontSize: 9,
    textAlign: "left",
  },
  header_mark: {
    width: 15,
    fontSize: 9,
    textAlign: "justify",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  text: {
    fontSize: 9,
    textAlign: "justify",
  },

  table: {
    display: "flex",
    flexDirection: "row",
    borderLeftWidth: 1,
    // borderRadius: 5,
    borderStyle: "solid",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  cell: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellSecondary: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderTop: 0,
    borderLeftWidth: 0,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellClosing: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  paddings: {
    paddingTop: 10,
  },
  logo: {
    width: 200,
    marginBottom: 20,
    marginLeft: 325,
  },
  Middleman: {
    width: 200,
    fontSize: 9,
  },
  header_RightA: {
    width: 135,
    marginRight: 5,
    fontSize: 9,
    textAlign: "left",
  },
  bottom_ttdNP: {
    marginTop: 50,
    fontWeight: "bold",
    fontSize: 9,
    border: 1,
    paddingLeft: 38,

    width: 132,
    borderBottom: 0,
  },
});

const combineStyles = (main, override) => {
  let result = { ...main };
  let ov = { ...override };
  if (typeof override === "object") {
    Object.assign(result, ov);
  }
  return result;
};
// Create Document Component
const BlankoPOReturn = (props) => {
  const data = props.data[0];

  const HeaderTableMaker = (props) => {
    let style = { width: props.width + "%" };
    let style2 = {};
    if (props.closing) style2 = { borderBottom: 1 };
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 22 };
    }
    if (props.colored) {
      style3 = {
        backgroundColor: "grey",
        color: "white",
      };
    }
    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cell, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };
  const SecondaryTableMaker = (props) => {
    let style = { width: props.width + "%" };
    let style2 = {};
    if (props.closing) {
      style2 = { borderBottom: 1 };
    }
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 22 };
    }

    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cellSecondary, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };

  let Total = 0;
  let TotalK = 0;
  data.Data &&
    data.Data.map((values, id) => {
      Total = Total + parseFloat(values.Debet);
      TotalK = TotalK + parseFloat(values.Kredit);
    });
  const GTotalK = TotalK;
  const GTotalD = Total;
  const HeaderTableMakerMid = (props) => {
    let style = {
      width: props.width + "%",
      textAlign: "center",
      paddingRight: 18,
    };
    let style2 = {};
    if (props.closing) style2 = { borderBottom: 1 };
    let style3 = {};
    if (props.colored) {
      style3 = {
        backgroundColor: "grey",
        color: "white",
      };
    }
    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cell, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <Image style={styles.logo} src={LOGO_RKS} />
        <View style={styles.viewHeader}>
          <Text style={styles.title_border}>Memo JURNAL</Text>
        </View>
        {/* <View>
          <Text style={styles.Stitle_border}>{data.AccountingID}</Text>
        </View> */}
        <View style={styles.header_section}>
          <Text style={styles.header_title}>{"Keterangan : "}</Text>
          <Text style={styles.header_Right}>{"No. MV"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.AccountingID}</Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_title}>{data.Keterangan}</Text>
          <Text style={styles.header_Right}>{"Tanggal"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>
            {new Date(data.Tanggal).toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })}
          </Text>
        </View>

        {/* <View style={styles.header_section}>
          <Text style={styles.header_title}>{}</Text>
        </View> */}
        {/*<View style={styles.header_section}>*/}
        {/*    <Text style={styles.header_title}>*/}
        {/*        {"ID Jurnal "}*/}
        {/*    </Text>*/}
        {/*    <Text style={styles.header_mark}>*/}
        {/*        :*/}
        {/*    </Text>*/}
        {/*    <Text style={styles.Middleman}>*/}
        {/*        {data.AccountingID}*/}
        {/*    </Text>*/}
        {/*</View>*/}

        {/*<View style={styles.header_section}>*/}
        {/*    <Text style={styles.header_title}>*/}
        {/*        {"Keterangan"}*/}
        {/*    </Text>*/}
        {/*    <Text style={styles.header_mark}>*/}
        {/*        :*/}
        {/*    </Text>*/}
        {/*    <Text style={styles.Middleman}>*/}
        {/*        {data.Keterangan}*/}
        {/*    </Text>*/}
        {/*</View>*/}
        {/*<View style={styles.header_section}>*/}
        {/*    <Text style={styles.header_title}>*/}
        {/*        {"Tanggal"}*/}
        {/*    </Text>*/}
        {/*    <Text style={styles.header_mark}>*/}
        {/*        :*/}
        {/*    </Text>*/}
        {/*    <Text style={styles.Middleman}>*/}
        {/*        {(new Date(data.Tanggal)).toDateString()}*/}
        {/*    </Text>*/}
        {/*</View>*/}
        <View style={styles.paddings}></View>
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <HeaderTableMakerMid colored={true} width={5} title={"No"} />
            <HeaderTableMakerMid
              colored={true}
              width={60}
              title={"Perkiraan"}
            />

            <HeaderTableMakerMid
              colored={true}
              width={20}
              title={"No. Perkiraan"}
            />
            <HeaderTableMakerMid colored={true} width={20} title={"Debet"} />
            <HeaderTableMakerMid colored={true} width={20} title={"Kredit"} />
          </View>
        </View>
        {data.Data &&
          data.Data.map((values, id) => {
            let closing = false;
            if (id === data.Data.length - 1) {
              closing = true;
            }
            return (
              <View style={styles.table}>
                <View style={[styles.tableRow]}>
                  <HeaderTableMaker
                    closing={closing}
                    width={5}
                    title={id + 1}
                  />
                  <HeaderTableMaker
                    closing={closing}
                    width={60}
                    title={values.NamaAccount}
                  />
                  <HeaderTableMaker
                    closing={closing}
                    width={20}
                    title={values.NomorAccount}
                  />
                  <HeaderTableMaker
                    number={true}
                    closing={closing}
                    width={20}
                    title={parseFloat(values.Debet).toLocaleString("in-ID", {
                      maximumFractionDigits: 2,
                    })}
                  />
                  <HeaderTableMaker
                    number={true}
                    closing={closing}
                    width={20}
                    title={parseFloat(values.Kredit).toLocaleString("in-ID", {
                      maximumFractionDigits: 2,
                    })}
                  />
                </View>
              </View>
            );
          })}

        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker width={65} closing={true} title={""} />
            <SecondaryTableMaker width={20} closing={true} title={"Total "} />
            <SecondaryTableMaker
              number={true}
              closing={true}
              width={20}
                title={GTotalD.toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
            //   title={0}
            />
            <SecondaryTableMaker
              number={true}
              closing={true}
              width={20}
              title={GTotalK.toLocaleString("in-ID", {
                maximumFractionDigits: 2,
              })}
            />
          </View>
        </View>
        <View style={styles.header_section}>
          <View style={styles.header_RightA}>
            <Text style={styles.bottom_ttdNP}> </Text>
            <Text style={styles.bottom_ttdL}>{"Nama: "}</Text>
            <Text style={styles.bottom_ttdB}>{"Tanggal: "}</Text>
          </View>
          <View style={styles.header_RightA}>
            <Text style={styles.bottom_ttdNP}>{"Dibuat oleh"}</Text>
            <Text style={styles.bottom_ttd}>{"_________________________"}</Text>
            <Text style={styles.bottom_ttdB}> </Text>
          </View>
          <View style={styles.header_RightA}>
            <Text style={styles.bottom_ttdNP}>{"Diperiksa oleh"}</Text>
            <Text style={styles.bottom_ttd}>{"Nasrul"}</Text>
            <Text style={styles.bottom_ttdB}> </Text>
          </View>
          <View style={styles.header_RightA}>
            <Text style={styles.bottom_ttdNP}>{"Disetujui oleh"}</Text>
            <Text style={styles.bottom_ttd}>{"Aldi Harris"}</Text>
            <Text style={styles.bottom_ttdB}> </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

const BlankoJurnal = () => {
  const params = useParams();
  const mutationGetBlanko = useMutation((formData) =>
    fetchGet("Accounting/" + formData)
  );

  useEffect(() => {
    if (params.id) {
      mutationGetBlanko.mutate(params.id.replaceAll("-", "/"));
    }
  }, []);

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-screen -mt-32">
        {mutationGetBlanko.data && (
          <PDFViewer className={"h-screen w-screen"}>
            {<BlankoPOReturn data={mutationGetBlanko.data.data} />}
          </PDFViewer>
        )}
      </div>
    </div>
  );
};
export default BlankoJurnal;
